import React, { useEffect, useState } from 'react'
import styles from "./Myproject.module.css"
import { useParams } from 'react-router-dom';
import { delete_project_Api, get_all_project_Api, update_project_Api } from '../../dashboardapi';
import { useToast } from '@chakra-ui/react';


const TrashedProjects = () => {
    const [projects, setProjects] = useState([]);

    const { project } = useParams();

    const toast = useToast();

    const fetchTrashedProjects = async () => {
        let response = await get_all_project_Api();
        if (response.data && response.data.trashed) {
            setProjects(response.data.trashed);
        } else {
            setProjects([])
        }
    };

    useEffect(() => {
        if (project === 'trashedprojects') {
            fetchTrashedProjects();
        }
    }, [])

    const handleDelete = async (id) => {
        let result = await delete_project_Api(id);
        if (result.data) {
            toast({
                title: "Project deleted Successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"

            })
            setProjects((prev) => prev.filter((items) => items.uuid !== id));
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Problem deleting project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"

            })
        }
    }

    const undelete = async (id) => {
        let result = await update_project_Api(id);
        if (result.data) {
            toast({
                title: "Project restored successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchTrashedProjects();
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Failed to restore project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    return (
        <div className={styles.product_page_outer}>
            <div className={styles.indivprojectouter}>
                <div className={styles.project_heading}>
                    <p>Trash</p>
                </div>
                <div className={styles.indivprojectlist}>
                    {projects.length > 0 ? projects.map((item, i) => (
                        <div key={i} className={styles.indivproject}>
                            <input type='text' name='name' onChange={""} value={item.name} style={{ background: "transparent", color: "var(--text-primary)" }}></input>
                            {/* <button>Go to editor</button> */}
                            <button onClick={() => undelete(item.uuid)} className={styles.untrash}>Add to my projects</button>
                            <hr style={{ borderColor: "var(--border)", marginTop: "24px", borderWidth: "1px" }} />
                            <div className={styles.fileactionbtn}>
                                {/* <button onClick={() => handleRename(item.name)}><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/edit.png"} alt='rename' /></button> */}
                                {/* <button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/settings.png"} alt='settings' /></button> */}
                                <button onClick={() => handleDelete(item.uuid)}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_45_3546)">
                                            <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_45_3546">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='delete' /> */}
                                </button>
                            </div>
                        </div>
                    )) : <p>No Projects in trash</p>}
                </div>
            </div>
        </div>
    )
}

export default TrashedProjects